import { Trigger } from '@radix-ui/react-dialog';
import { forwardRef, PropsWithChildren } from 'react';
import FilterIcon from '~/icons/filter.svg';
import { Button } from '~/shared/components/Button/Button';

export type FacetsOverlayTriggerProps = PropsWithChildren<unknown>;

export const FacetsOverlayTrigger = forwardRef<HTMLButtonElement, FacetsOverlayTriggerProps>(({ children }, forwardedRef) => (
	<Trigger
		asChild
		ref={forwardedRef}
	>
		<Button
			variant={'plain'}
			icon={<FilterIcon />}
			iconAlignment={'start'}
		>
			{children}
		</Button>
	</Trigger>
));
